<template>
  <div class="tour-allocation">
    <div class="tour-allocation__top">
      <div class="tour-allocation__top-icon u-flex-shrink-0">
        <svg-inline>
          <icon icon="building" />
        </svg-inline>
      </div>
      <div class="tour-allocation__top-content u-flex-grow">
        <div class="font-h2">
          <span v-if="tour.hotel_name" v-html="tour.hotel_name"></span>
          <span v-if="tour.hotel_name && typeAllocationText.length">, </span>
          <span v-if="typeAllocationText.length">
            {{ typeAllocationText }}</span
          >
        </div>
      </div>
    </div>

    <div class="tour-program__block">
      <div class="tour-program__block-title"
           v-text="tour.comfort_data.title"/>

      <div class="tour-program__block-value">
        <span>{{ tour.comfort_data.title_select }}</span>
        <circles-scale :position="tour.comfort/2"/>
      </div>

      <div class="tour-program__block-description"
           v-text="tour.comfort_data.description"/>

    <div v-if="gallery.length" class="tour-allocation__gallery">
      <gallery :gallery="gallery" />
    </div>
    </div>
  </div>
</template>

<script>
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";
import CirclesScale from "@/components/ui-kit/circles-scale/index.vue";
import Gallery from "@/components/organisms/gallery/index.vue";
import { sizeSm, sizeLg } from "@/assets/js/utils/mq";
import { isObjectValuesEmpty } from "@/assets/js/utils/is-object-values-empty";

export default {
  components: {
    SvgInline,
    Icon,
    Gallery,
    CirclesScale,
  },
  props: {
    tour: {
      type: Object,
      required: true,
    },
  },
  computed: {
    typeAllocationText() {
      return this.typeAllocationArray.map(({ name }) => name).join(", ");
    },
    typeAllocationArray() {
      return Array.isArray(this.tour.type_allocation)
        ? this.tour.type_allocation
        : isObjectValuesEmpty(this.tour.type_allocation)
        ? []
        : [this.tour.type_allocation];
    },

    gallery() {
      return (
        this.tour.photo_allocation?.map(({ path }, index) => ({
          id: index,
          path,
        })) || []
      );
    },
    sizeSm,
    sizeLg,
  },
};
</script>

<style lang="scss" scoped>
.tour-allocation {
  &__top {
    display: flex;
    align-items: center;

    &-icon {
      width: 24px;
      margin-right: 16px;
    }
  }

  &__gallery {
    margin-top: 24px;

    @include mixin.size-md-only {
      margin-top: 32px;
    }

    @include mixin.size-xl-min {
      margin-top: 32px;
    }
  }
}
</style>
